module.exports = __webpack_public_path__ + "img/croissant_2.021f96ca.jpg";